module.exports = __webpack_public_path__ + "static/img/image_recruit_03.7db8682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_03.png
// module id = M++M
// module chunks = 10